import { POCItem } from "./POCItem";
import { Messages } from "../../../core/api";
import { Card, CardBody, Flex } from "@chakra-ui/react";

interface POCDocumentQuestionUIProps {
  questionId: number;
  questionText: string;
  currentAnswer: Messages["POCItemsDocumentAnswer"][] | null;
  POCItems: Messages["PatientDocumentPOCItem"][];
  isRequired: boolean;
  readonly: boolean;
  onTaskCheck: (itemName: string) => void;
  onWhenToPerformChange: (
    itemName: string,
    whenToPerform: Messages["TaskWhenToPerformNursing"]
  ) => void;
  onFrequencyChange: (itemName: string, frequency: number, visitsInAWeek: number) => void;
}

export function POCDocumentQuestionUI(props: POCDocumentQuestionUIProps) {
  return (
    <Card>
      <CardBody>
        <Flex flexWrap="wrap" gap={4}>
          {props.POCItems.map((item, index) => (
            <POCItem
              key={index}
              currentAnswer={props.currentAnswer}
              index={index}
              isRequired={props.isRequired}
              item={item}
              readonly={props.readonly}
              onFrequencyChange={props.onFrequencyChange}
              onTaskCheck={props.onTaskCheck}
              onWhenToPerformChange={props.onWhenToPerformChange}
            />
          ))}
        </Flex>
      </CardBody>
    </Card>
  );
}
